import {types} from '../../types';

const setGetPinsaleAction = (payload) => {
  return {
    type: types.pinsale.SET_LIST,
    payload,
  }
}

const setGetPinsaleByIdAction = (payload) => {
  return {
    type: types.pinsale.SET_EDIT,
    payload,
  }
}

export {
  setGetPinsaleAction as setGetPinsaleAction,
  setGetPinsaleByIdAction,
}